module.exports = __webpack_public_path__ + "a98fab2c69891dd9eb37b1bca13dbec1.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/onboarding/icons/assignment-gray.png
// module id = 1098
// module chunks = 0